module.exports = __webpack_public_path__ + "static/tunic-b3326191c625f1496470f3abec12b4c2.png";